import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { GoogleOAuthProvider } from "@react-oauth/google";
import React from "react";
import ReactDOM from "react-dom/client";
import "string.prototype.matchall/auto";
import App from "./App";
import { Toast } from "./components/toast";
import "./index.css";
import { StoreProvider } from "./redux/provider";
import reportWebVitals from "./reportWebVitals";
import { GOOGLE_CLIENT_ID } from "./utils/constants";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <StoreProvider>
      <GoogleOAuthProvider clientId={`${GOOGLE_CLIENT_ID}`}>
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <Toast />
          <App />
        </LocalizationProvider>
      </GoogleOAuthProvider>
    </StoreProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
